import React from 'react'
import styles from './serviceDetailSec.module.css'
import Marquee from 'react-fast-marquee';
import { partner1, partner10, partner11, partner12, partner13, partner14, partner15, partner16, partner17, partner2, partner3, partner4, partner5, partner6, partner7, partner8, partner9 } from '../../../assets';
import { IMAGE_URL } from '../../helpers/api_helper';

const ServiceDetailMarque = ({partnerData}) => {
    const imgs = [
        partner1,
        partner2,
        partner3,
        partner4,
        partner5,
        partner6,
        partner7,
        partner8,
        partner9,
        partner10,
        partner11,
        partner12,
        partner13,
        partner14,
        partner15,
        partner16,
        partner17,
    ]
    return (
        <div className={styles.ServiceDetailMarque}>
            <Marquee speed="150">
                <div className={styles.ServiceDetailMarqueInner}>
                    <ul className={styles.ServiceDetailMarqueCont}>
                        {partnerData.length > 0 && partnerData.map((img, index) => (
                            <li key={index}>
                                {/* <img src={img} alt="" /> */}
                                <img src={`${IMAGE_URL}/partners/${img.image}`} alt={`Slide ${index + 1}`} />
                            </li>
                        ))}
                    </ul>
                </div>
            </Marquee>
        </div>
    )
}

export default ServiceDetailMarque
